import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { NewUserForm } from "@app/definitions/types"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { Modalable } from "@app/Modalable"
import { BtnExtComponent, CancelBtnComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-new-user",
	imports: [
		COMMON_IMPORTS,
		GenInputComponent,
		CancelBtnComponent,
		BtnExtComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		@for (
			field of ["name", "email", "phone_mobile", "campaign_id"];
			track field
		) {
			<div class="row form-group">
				<app-gen-input
					[actualObj]="newUserForm"
					[errors]="errors"
					[fieldName]="field"
					(keyupEvent)="validateEntireForm()"
				/>
			</div>
		}

		<div class="modal-btns">
			<app-cancel-btn (click)="onClose.emit()" />
			<app-btn-ext
				text="confirm"
				(clickEv)="submit()"
				[disabled]="!isFormSubmittable"
				[isSpin]="saving"
			/>
		</div>
	`,
})
export class NewUserComponent extends Modalable {
	//used to be for registering potential users - DO NOT DELETE
	newUserForm = new NewUserForm() //the object that holds the field values (and is saved)
	errors: any = {} //will hold errors for the fields in the form
	isFormSubmittable: boolean = false //can submit (controls disabled in the submit button)
	validationFields: any = {
		//field validations, control displaying field errors and ability to submit the form
		email: { not_empty: true, email: null },
		phone_mobile: { not_empty: null },
		name: { not_empty: null },
	}
	saving: boolean = false

	validateEntireForm() {
		//validate all fields and detrmine if can be submitted (or has errors)
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.newUserForm,
			this.errors,
			this.validationFields
		)
	}

	async submit() {
		//send form values to the api
		if (!this.isFormSubmittable) {
			return
		} //has errors - exit
		this.saving = true
		const res: any = await this.apiService.post(
			"create_potential_user",
			this.newUserForm
		)
		this.saving = false
		if (res.success) {
			this.modalService.openToast("sent_successfully") //toast a success message
			this.onClose.emit()
		} else {
			this.modalService.openToast("save_failed") //toast a success message
			if (res?.errors?.length) {
				res.errors.forEach((field) => {
					this.errors[field] = this.lang.getVal("field_must_be_unique")
				})
			}
		}
	}
}
